import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";

export default class ReservasAyB {
  constructor() { }

  static getDocData(mainData) {
    let totalReservacionesGral = 0;
    let totalPersonasGral = 0;

    // Calculate general totals
    if (mainData && mainData.reservas) {
      Object.values(mainData.reservas).forEach(area => {
        if (area && area.Rva) {
          totalReservacionesGral += area.Rva.length;
          area.Rva.forEach(reserva => {
            totalPersonasGral += Number(reserva.px || 0);
          });
        }
      });
    }

    let docDefinition = {
      pageMargins: [30, 30, 30, 30],
      pageOrientation: "portrait",
      info: {
        title: "Reporte de Reservas AYB",
        author: 'ITS'
      },
      content: [
        // Header
        {
          text: mainData.TITLE || "Reporte de Reservas AYB",
          fontSize: 18,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10],
          color: "#1a237e"
        },
        // Metadata Info
        {
          columns: [
            {
              text: [
                { text: "Fecha del Reporte: ", bold: true },
                (mainData.FI || "") + "\n"
              ],
              fontSize: 10,
              alignment: "left"
            },
            {
              text: [
                { text: "Generado: ", bold: true },
                (mainData.FG || "") + " " + (mainData.HG || "") + "\n"
              ],
              fontSize: 10,
              alignment: "right"
            }
          ],
          margin: [0, 0, 0, 15]
        },
        // Global Summary Box
        {
          table: {
            widths: ["*", "*"],
            body: [
              [
                {
                  text: [
                    { text: "Total Reservas: ", bold: true, color: "#1a237e" },
                    totalReservacionesGral.toString()
                  ],
                  alignment: "center",
                  fillColor: "#f5f5f5",
                  margin: [6, 6, 6, 6],
                  fontSize: 11
                },
                {
                  text: [
                    { text: "Total Comensales (Pax): ", bold: true, color: "#1a237e" },
                    totalPersonasGral.toString()
                  ],
                  alignment: "center",
                  fillColor: "#f5f5f5",
                  margin: [6, 6, 6, 6],
                  fontSize: 11
                }
              ]
            ]
          },
          margin: [0, 0, 0, 20],
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => "#e0e0e0",
            vLineColor: () => "#e0e0e0"
          }
        }
      ]
    };

    // Check if we have reservations to render
    if (!mainData || !mainData.reservas || Object.keys(mainData.reservas).length === 0) {
      docDefinition.content.push({
        text: "No hay reservaciones registradas para esta fecha.",
        alignment: "center",
        fontSize: 12,
        margin: [0, 20, 0, 0],
        italics: true
      });
      return docDefinition;
    }

    // Render each Area
    let sortedAreas = Object.values(mainData.reservas)
      .filter(area => area && area.Rva && area.Rva.length > 0)
      .sort((a, b) => {
        if (a.Nombre === "Mesa no asignada") return 1;
        if (b.Nombre === "Mesa no asignada") return -1;
        return (a.Nombre || "").localeCompare(b.Nombre || "");
      });

    sortedAreas.forEach((area, index) => {
      // Area Title
      docDefinition.content.push({
        text: area.Nombre || "Sin Área",
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 6],
        color: "#0d47a1"
      });

      // Build reservation rows
      let tableBody = [];

      // Header Row
      tableBody.push([
        { text: "Hora", bold: true, fillColor: "#e3f2fd", fontSize: 9, alignment: "center", margin: [0, 4, 0, 4] },
        { text: "Cliente", bold: true, fillColor: "#e3f2fd", fontSize: 9, margin: [0, 4, 0, 4] },
        { text: "Mesa", bold: true, fillColor: "#e3f2fd", fontSize: 9, alignment: "center", margin: [0, 4, 0, 4] },
        { text: "Pax", bold: true, fillColor: "#e3f2fd", fontSize: 9, alignment: "center", margin: [0, 4, 0, 4] },
        { text: "Teléfono", bold: true, fillColor: "#e3f2fd", fontSize: 9, alignment: "center", margin: [0, 4, 0, 4] },
        { text: "Notas", bold: true, fillColor: "#e3f2fd", fontSize: 9, margin: [0, 4, 0, 4] }
      ]);

      let areaPaxTotal = 0;

      // Sort reservations within this area by time/hour, then by client name
      let sortedRva = _.orderBy(area.Rva, ["hora", "cn"], ["asc", "asc"]);

      sortedRva.forEach((reserva) => {
        areaPaxTotal += Number(reserva.px || 0);

        tableBody.push([
          { text: reserva.hora || "", fontSize: 9, alignment: "center", margin: [0, 3, 0, 3] },
          { text: (reserva.cn || "").trim(), fontSize: 9, margin: [0, 3, 0, 3] },
          { text: reserva.ms ? (reserva.ms.nm || "") : "No asignada", fontSize: 9, alignment: "center", margin: [0, 3, 0, 3] },
          { text: (reserva.px || 0).toString(), fontSize: 9, alignment: "center", margin: [0, 3, 0, 3] },
          { text: reserva.tl || "-", fontSize: 9, alignment: "center", margin: [0, 3, 0, 3] },
          { text: reserva.nt || "-", fontSize: 8, margin: [0, 3, 0, 3] }
        ]);
      });

      // Subtotal row
      tableBody.push([
        { text: "Total Área", bold: true, fontSize: 9, alignment: "left", colSpan: 3, margin: [4, 4, 4, 4], fillColor: "#fafafa" },
        {},
        {},
        { text: areaPaxTotal.toString(), bold: true, fontSize: 9, alignment: "center", margin: [4, 4, 4, 4], fillColor: "#fafafa" },
        { text: `${area.Rva.length} reservaciones`, bold: true, fontSize: 9, alignment: "center", colSpan: 2, margin: [4, 4, 4, 4], fillColor: "#fafafa" },
        {}
      ]);

      // Add table to definition
      docDefinition.content.push({
        table: {
          widths: ["8%", "26%", "12%", "8%", "18%", "28%"],
          headerRows: 1,
          body: tableBody
        },
        layout: {
          hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 1.2 : 0.5,
          vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length) ? 1.2 : 0.5,
          hLineColor: (i, node) => (i === 0 || i === node.table.body.length) ? "#0d47a1" : "#e0e0e0",
          vLineColor: (i, node) => (i === 0 || i === node.table.widths.length) ? "#0d47a1" : "#e0e0e0"
        },
        margin: [0, 0, 0, 15],
        pageBreak: index < sortedAreas.length - 1 ? 'after' : undefined
      });
    });

    return docDefinition;
  }
}
